import "./category.css"

function Category() {
    return (
        <div className="category">
            <div className="category-container">
                <h2>دسته بندی کالا ها</h2>
                <div className="cat-images">
                    <img src="../../images/cat1.jpg" alt="" />
                    <img src="../../images/cat2.jpg" alt="" />
                    <img src="../../images/cat3.jpg" alt="" />
                    <img src="../../images/cat4.jpg" alt="" />
                </div>
            </div>
        </div>
    )
}

export default Category;